import http from "@/http-common";

const BASE_URL = "/package-student/package";

const unwrap = (response) => response.data.data;

const normalizePackage = (item) => ({
  ...item,
  id: Number(item.id),
  limit: Number(item.limitStudents || 0),
  createdAt: item.createdDate || item.createdAt,
  active: Boolean(item.active),
});

const normalizeBatchResult = (result) => ({
  ...result,
  results: (result && result.results ? result.results : []).map((item) => ({
    ...item,
    data: item.data ? normalizePackage(item.data) : item.data,
  })),
});

class PackageService {
  search({ keyword, active, page = 0, size = 10 } = {}) {
    const params = { page, size };
    if (keyword && keyword.trim()) params.keyword = keyword.trim();
    if (active !== undefined && active !== null) params.active = active;

    return http.get(`${BASE_URL}/search`, { params }).then((response) => ({
      items: (unwrap(response) || []).map(normalizePackage),
      total: Number(response.data.total || 0),
    }));
  }

  getAll(activeOnly = false) {
    return http.get(`${BASE_URL}/list`, { params: { activeOnly } })
      .then((response) => (unwrap(response) || []).map(normalizePackage));
  }

  create(data) {
    return http.post(`${BASE_URL}/create-batch`, {
      packages: [{
        name: String(data.name || "").trim(),
        limitStudents: Number(data.limit),
      }],
    }).then((response) => normalizeBatchResult(unwrap(response)));
  }

  update(id, data) {
    return http.put(`${BASE_URL}/update/${id}`, {
      name: String(data.name || "").trim(),
      limitStudents: Number(data.limit),
    }).then((response) => normalizePackage(unwrap(response)));
  }

  setActive(id, active) {
    return this.setActiveMany([id], active);
  }

  setActiveMany(ids, active) {
    return http.post(`${BASE_URL}/change-status-batch`, {
      ids: ids.map((id) => Number(id)),
      active: Boolean(active),
    }).then((response) => normalizeBatchResult(unwrap(response)));
  }
}

export default new PackageService();
